import {useEffect, useMemo, useState} from "react"
import {Offcanvas} from "react-bootstrap"
import {Outlet} from "react-router-dom"
import {useTranslation} from "react-i18next"
import MainNavbar from "./MainNavbar"
import MainSidebar from "./MainSidebar"
import {useAuth} from "../../context/AuthProvider"
import {getNavigationItems, NavigationItem} from "./navigation.config"
import styles from "./MainNavigation.module.scss"

export default function AppLayout() {
    const auth = useAuth()
    const {t} = useTranslation(["common", "tenant", "navigation"])

    const [showSidebarMobile, setShowSidebarMobile] = useState(false)
    const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(() => {
        return localStorage.getItem("sidebar-collapsed") === "true"
    })

    const visibleNavigationItems = useMemo(() => {
        return getNavigationItems(auth, t).filter(
            (item: NavigationItem) => item.visible
        )
    }, [auth, t])

    const workspaceCount = visibleNavigationItems.filter(
        (item: NavigationItem) => item.section === "workspace"
    ).length

    const hasAdministration = visibleNavigationItems.some(
        (item: NavigationItem) => item.section === "administration"
    )

    const showSidebar = hasAdministration || workspaceCount >= 3

    const toggleSidebar = () => {
        const next = !sidebarCollapsed
        setSidebarCollapsed(next)
        localStorage.setItem("sidebar-collapsed", next.toString())
    }

    useEffect(() => {
        if (!showSidebar) {
            setShowSidebarMobile(false)
        }
    }, [showSidebar])

    return (
        <>
            <MainNavbar
                showSidebar={showSidebar}
                sidebarCollapsed={sidebarCollapsed}
                toggleSidebar={toggleSidebar}
                openSidebar={() => setShowSidebarMobile(true)}
            />

            <div className={styles.appShell}>
                {showSidebar && (
                    <>
                        <div className="d-none d-lg-block">
                            <MainSidebar collapsed={sidebarCollapsed}/>
                        </div>

                        <Offcanvas
                            show={showSidebarMobile}
                            onHide={() => setShowSidebarMobile(false)}
                            placement="start"
                            className={styles.offcanvasSidebar}
                        >
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>
                                    {t("title", {ns: "navigation"})}
                                </Offcanvas.Title>
                            </Offcanvas.Header>

                            <Offcanvas.Body className="p-0">
                                <MainSidebar
                                    collapsed={false}
                                    onNavigate={() => setShowSidebarMobile(false)}
                                />
                            </Offcanvas.Body>
                        </Offcanvas>
                    </>
                )}

                <main className={styles.content}>
                    <Outlet/>
                </main>
            </div>
        </>
    )
}
